import React, { useEffect, useState } from "react";
import { fetchOrders } from "../utils/api";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaReceipt } from "react-icons/fa";

const Orders = () => {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        getOrders();
    }, []);

    const getOrders = async () => {
        try {
            const data = await fetchOrders();
            setOrders(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));

        } catch (error) {
            console.error("Feil ved henting av ordrer:", error);
        }
    };

    const getStatus = (status) => {
        if (status === "pending") {
            return <span className="text-orange-500 font-semibold">Venter</span>;
        } else if (status === "completed") {
            return <span className="text-green-500 font-semibold">Betalt</span>;
        } else {
            return <span className="text-blue-500 font-semibold">Fullført</span>;
        }
    };


    const openEditModal = (order) => {
        console.log("Åpner modal for redigering av ordre:", order);
    };

    return (
        <div className="p-4 md:p-6">
            <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">Ordrer</h1>

            <div className="bg-white shadow-md rounded-lg overflow-x-auto">
                <table className="w-full border-collapse text-xs md:text-sm">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="p-2 md:p-3 text-left">Dato</th>
                            <th className="p-2 md:p-3 text-left">Navn</th>
                            <th className="p-2 md:p-3 text-left">Telefon</th>
                            <th className="p-2 md:p-3 text-left">Total</th>
                            <th className="p-2 md:p-3 text-left">Leveringsmetode</th>
                            <th className="p-2 md:p-3 text-left">Status</th>
                            <th className="p-2 md:p-3 text-right">Handling</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order._id} className="border-t">
                                <td className="p-2 md:p-3">{new Date(order.createdAt).toLocaleString("no-NO", { dateStyle: "short", timeStyle: "short" })}</td>
                                <td className="p-2 md:p-3">{order.customerName}</td>
                                <td className="p-2 md:p-3">+{order.customerPhone}</td>
                                <td className="p-2 md:p-3">{order.totalAmount} NOK</td>
                                <td className="p-2 md:p-3">{order.deliveryMethod === "pickup" ? "Henting" : "Levering"}</td>
                                <td className="p-2 md:p-3">{getStatus(order.status)}</td>
                                <td className="p-2 md:p-3 flex gap-5 align-center justify-end">
                                    <Link to={`/orders/${order._id}`} className="text-blue-500 hover:text-blue-700">
                                        <FaEye size={20}/>
                                    </Link>
                                    <button onClick={() => openEditModal(order)} className="text-green-500 hover:text-green-700">
                                        <FaEdit size={20}/>
                                    </button>
                                    {order.receiptUrl && (
                                        <a 
                                            href={order.receiptUrl}
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="text-purple-500 hover:text-purple-700"
                                        >
                                            <FaReceipt size={20} alt="Kvittering" />
                                        </a>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Orders;
